import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TrainingProgramApplicationProcessInfoModel } from 'src/app/models/training-program-application-process-info.model';
import { environment } from 'src/environments/environment';
import { StatusServiceInterface } from './status.interface';


@Injectable({
  providedIn: 'root'
})
export class StatusService implements StatusServiceInterface {
  trainingProgramDetailsInfo: TrainingProgramApplicationProcessInfoModel;

  constructor(private httpClient: HttpClient) { }

  SetDapResponseIssued(courseApprovalId: string): Observable<any> {
    return this.httpClient.get<any>(environment.apiBaseUrl + `status/SetDapResponded/${courseApprovalId}`);
  }
}
